import React, { forwardRef, useEffect, useRef } from 'react';
import { useONLYOFFICE } from './hooks';
import loadingSvg from './loading.svg'
import styled from 'styled-components'

interface Props {
  hostUrl?: string;
  editorConfig?: any;
  loading?: boolean;
  editorId?: string;
  style?: React.CSSProperties;
}

const Wrapper = styled.div`
position: relative;
width: 100%;
height: 100%;
`
const Mask = styled.div`
position: absolute;
z-index: 10;
display: flex;
align-items: center;
justify-content: center;
width: 100%;
height: 100%;
`
const Editor = styled.div`
width: 100%;
height: 100%;
`

export const OnlyOfficeEditor = forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
  const { editorId = 'officeEditor', hostUrl } = props;
  const editor = useRef<any>();
  const { docsAPI, isLoaded } = useONLYOFFICE(hostUrl);
  const { editorConfig } = props;

  useEffect(() => {
    if (!isLoaded || !docsAPI || !editorConfig) return;

    if (editor.current) {
      editor.current.destroyEditor();
    }
    editor.current = new docsAPI.DocEditor(editorId, editorConfig);
  }, [docsAPI, isLoaded, editorConfig, editorId]);

  return (
    <Wrapper>
      {props.loading && (
        <Mask>
          <img src={loadingSvg} alt="" />
        </Mask>
      )}
      <Editor style={props.style} ref={ref}>
        <div id={editorId} />
      </Editor>
    </Wrapper>
  );
});
